import { useContext } from 'react';
import { graphqlFetch } from '@shared/api';
import { feedQueryDocument } from '../api/games.document';
import { useQuery } from '@tanstack/react-query';

import { AppContext } from '@/app.context';
import { Issue, USER_ROLE } from '@/constants';
import { getQueryCacheOptions } from '@shared/query-client/query-client';

export const ISSUE_ID_GAMES = 1634;

export function useGetGames(): GetFeedResponse {
	const isAdmin = localStorage.getItem(USER_ROLE) === 'admin';
	const {
		parseGraphQLClientError,
		onlineStatus: isOnline,
	} = useContext(AppContext);

	const cacheOptions = getQueryCacheOptions({
		isOnline,
		isAdmin,
		ttlMinutes: 1,
	});
	const { data, isPending, error } = useQuery<{ issue: Issue | null }>({
		queryKey: ['games'],
		queryFn: async () =>
			// Cast: generated type's nullability is honest where the shared
			// Issue/Article types claim required fields; reconciling that is
			// topic 5's separate "derive Issue/Article/Style from generated
			// types" step.
			graphqlFetch(feedQueryDocument, {
				id: ISSUE_ID_GAMES,
				sortKey: 'INDEX',
				reverse: false,
			}) as unknown as Promise<{ issue: Issue | null }>,
		staleTime: cacheOptions.staleTime,
		gcTime: cacheOptions.gcTime,
	});

	return {
		issue: data?.issue || null,
		isLoading: isPending,
		error: error ? parseGraphQLClientError(error) : null,
	};
}

export interface GetFeedResponse {
	issue: Issue | null;
	isLoading: boolean;
	error?: Error | null;
}
